import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService implements OnDestroy {
  private readonly IDLE_TIMEOUT = 30 * 60 * 1000;      // 30 دقيقة بدون نشاط
  private readonly CONFIRM_TIMEOUT = 5 * 60 * 1000;    // 5 دقائق للرد على رسالة التأكيد

  private idleTimer: any = null;
  private confirmTimer: any = null;
  private dialogVisible = false;

  private readonly events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

  private onDialogShow: (() => void) | null = null;
  private onForceLogout: (() => void) | null = null;

  constructor(private tokenService: TokenService, private ngZone: NgZone) {}

  /**
   * بدء مراقبة النشاط
   */
  start(onDialogShow: () => void, onForceLogout: () => void): void {
    this.onDialogShow = onDialogShow;
    this.onForceLogout = onForceLogout;

    this.ngZone.runOutsideAngular(() => {
      this.events.forEach(event =>
        document.addEventListener(event, this.onActivity, { passive: true })
      );
    });

    this.resetIdleTimer();
  }

  /**
   * إيقاف المراقبة
   */
  stop(): void {
    this.clearAllTimers();
    this.events.forEach(event =>
      document.removeEventListener(event, this.onActivity)
    );
  }

  /**
   * المستخدم اختار الاستمرار
   */
  continueSession(): void {
    this.dialogVisible = false;
    this.clearConfirmTimer();
    this.resetIdleTimer();
  }

  /**
   * المستخدم اختار الخروج أو انتهت المهلة
   */
  logout(): void {
    this.stop();
    this.tokenService.fullCleanup();
    window.location.href = '/login';
  }

  private onActivity = (): void => {
    if (!this.dialogVisible) {
      this.resetIdleTimer();
    }
  };

  private resetIdleTimer(): void {
    clearTimeout(this.idleTimer);
    this.idleTimer = setTimeout(() => {
      if (this.tokenService.isAuthenticated()) {
        this.showConfirmDialog();
      }
    }, this.IDLE_TIMEOUT);
  }

  private showConfirmDialog(): void {
    this.dialogVisible = true;

    this.ngZone.run(() => {
      this.onDialogShow?.();
    });

    this.confirmTimer = setTimeout(() => {
      this.ngZone.run(() => {
        this.onForceLogout?.();
        this.logout();
      });
    }, this.CONFIRM_TIMEOUT);
  }

  private clearConfirmTimer(): void {
    clearTimeout(this.confirmTimer);
    this.confirmTimer = null;
  }

  private clearAllTimers(): void {
    clearTimeout(this.idleTimer);
    this.clearConfirmTimer();
    this.idleTimer = null;
    this.dialogVisible = false;
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
